var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TE_ROOT_USER } from "@timeedit/types/lib/constants/permissions.constant";
import { ETokenType } from "@timeedit/types/lib/enums";
import { AUTH_TOKEN_NAME, SUCCESS_STATUS } from "../constants";
import { runLoginIframe, runLogoutIframe } from "../utils/runIframe";
export const setAuthToken = (authTokenContentObj) => {
    localStorage.setItem(AUTH_TOKEN_NAME, JSON.stringify(authTokenContentObj));
};
export const getAuthToken = () => {
    const unparsedToken = localStorage.getItem(AUTH_TOKEN_NAME);
    if (!unparsedToken) {
        return null;
    }
    return JSON.parse(unparsedToken);
};
export const clearAuthToken = () => {
    localStorage.removeItem(AUTH_TOKEN_NAME);
};
export const getRemoteAuthTokenSilently = (authUrl, enableLogs) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        return (_a = (yield runLoginIframe(authUrl, enableLogs))) !== null && _a !== void 0 ? _a : null;
    }
    catch (_b) {
        return null;
    }
});
export const clearRemoteAuthTokenSilently = (authUrl, enableLogs) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const result = yield runLogoutIframe(authUrl, enableLogs);
        return result.status === SUCCESS_STATUS;
    }
    catch (_a) {
        return false;
    }
});
export const getAccessToken = () => {
    var _a, _b;
    try {
        return (_b = (_a = getAuthToken()) === null || _a === void 0 ? void 0 : _a.accessToken) !== null && _b !== void 0 ? _b : null;
    }
    catch (_c) {
        return null;
    }
};
const tokenPassesAuthorization = ({ scopes }, appId) => scopes.includes(TE_ROOT_USER) ||
    scopes.some((scope) => scope.includes(appId));
export const tokenPassesValidation = (decodedToken, appId) => {
    if (!decodedToken.exp ||
        decodedToken.exp <= Date.now() / 1000 ||
        decodedToken.type !== ETokenType.USER ||
        !decodedToken.id ||
        !decodedToken.organizationId)
        return false;
    return tokenPassesAuthorization(decodedToken, appId);
};
